// Technical terms whose casing must be preserved in Title Case labels.
const TERMS = [
    "OAuth", "API", "ID", "IDs", "URL", "URLs", "URI", "SFTP", "FTP", "FTPS", "S3", "SQL", "SSL", "SSH",
    "TLS", "AWS", "GCP", "GA4", "MCC", "JSON", "CSV", "XML", "HTTP", "HTTPS", "DB", "IAM", "KMS", "ARN",
    "SAS", "JDBC", "ODBC", "DSN", "MFA", "CRM", "UUID", "IP", "JWT", "SSO", "SAML", "PEM", "ETL", "ADLS",
];
const TERM_MAP = Object.fromEntries(TERMS.map((t) => [t.toLowerCase(), t]));

function caseWord(word) {
    const m = word.match(/^([^A-Za-z0-9]*)([A-Za-z0-9][A-Za-z0-9_']*)?(.*)$/);
    if (!m || !m[2]) return word;
    const [, pre, core, post] = m;
    const term = TERM_MAP[core.toLowerCase()];
    let out;
    if (term) out = term;
    else if (core === core.toLowerCase() || core === core.toUpperCase()) out = core.charAt(0).toUpperCase() + core.slice(1).toLowerCase();
    else out = core.charAt(0).toUpperCase() + core.slice(1);
    return pre + out + post;
}

/** "LOGIN CUSTOMER ID (MANAGER)" / "oauth client id" → "Login Customer ID (Manager)" / "OAuth Client ID". */
export function toTitleLabel(label) {
    if (label === null || label === undefined) return label;
    return String(label).split(/(\s+|\/|-)/).map((part) => (/^(\s+|\/|-)$/.test(part) ? part : caseWord(part))).join("");
}
